import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CtaBanner() {
  return (
    <section className="bg-primary py-10 px-6 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        <p className="font-head text-lg md:text-xl font-bold uppercase tracking-[0.1em] text-black text-center sm:text-left">
          Ready to drive new trucks and earn more?
        </p>
        <Link
          to="/apply"
          className="shrink-0 inline-flex items-center gap-3 font-head text-sm uppercase tracking-[0.25em] bg-black text-primary px-10 py-4 hover:bg-white hover:text-black transition-colors duration-300"
        >
          Apply Now <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
